import { Helmet } from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionTagsPosts from "./SectionTagsPosts";

const BlogByTagPage: React.FC = () => {
  return (
    <div className="relative overflow-hidden nc-BlogPage">
      <Helmet>
        <title>EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France</title>
      </Helmet>
      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />
      {/* ======= Section Tags ============= */}
      <div className="container relative">
        <SectionTagsPosts className="py-16 lg:py-28" />
      </div>
    </div>
  );
};

export default BlogByTagPage;
